/* Tessera colour -> photo map. Generated by visual analysis of product photos.
   Keys: product handle -> colour (lowercase) -> image filename fragment.
   Edit freely: to fix a wrong photo, change the filename; to disable one, delete its line. */
window.TESSERA_COLOR_MAP = {
/* Basic Line: all five products carry the same sixty photos (six shots x
   ten colours), so each product is pointed at the one shot that pictures
   that item. The six shots are NOT in the same order in every colour -
   they came from separate folders - so the shot number varies by colour. */
 "prestige-basic-line-flat-sheet-set": {
  "baby blue": "basic-baby-blue-01",
  "beige": "basic-beige-01",
  "brown": "basic-brown-01",
  "burgundy": "basic-burgundy-01",
  "dark blue": "basic-dark-blue-02",
  "dark green": "basic-dark-green-06",
  "light green": "basic-light-green-06",
  "mint": "basic-mint-06",
  "olive": "basic-olive-06",
  "rose pink": "basic-rose-pink-06"
 },
 "prestige-basic-line-fitted-sheet-set": {
  "baby blue": "basic-baby-blue-03",
  "beige": "basic-beige-06",
  "brown": "basic-brown-05",
  "burgundy": "basic-burgundy-06",
  "dark blue": "basic-dark-blue-06",
  "dark green": "basic-dark-green-05",
  "light green": "basic-light-green-03",
  "mint": "basic-mint-02",
  "olive": "basic-olive-02",
  "rose pink": "basic-rose-pink-01"
 },
 "prestige-basic-line-duvet-cover-set": {
  "baby blue": "basic-baby-blue-05",
  "beige": "basic-beige-04",
  "brown": "basic-brown-04",
  "burgundy": "basic-burgundy-04",
  "dark blue": "basic-dark-blue-05",
  "dark green": "basic-dark-green-01",
  "light green": "basic-light-green-05",
  "mint": "basic-mint-03",
  "olive": "basic-olive-01",
  "rose pink": "basic-rose-pink-03"
 },
 "prestige-basic-line-flap-pillow-case-set": {
  "baby blue": "basic-baby-blue-06",
  "beige": "basic-beige-03",
  "brown": "basic-brown-02",
  "burgundy": "basic-burgundy-05",
  "dark blue": "basic-dark-blue-03",
  "dark green": "basic-dark-green-04",
  "light green": "basic-light-green-02",
  "mint": "basic-mint-05",
  "olive": "basic-olive-05",
  "rose pink": "basic-rose-pink-04"
 },
 "prestige-basic-line-oxford-pillow-case-set": {
  "baby blue": "basic-baby-blue-04",
  "beige": "basic-beige-02",
  "brown": "basic-brown-03",
  "burgundy": "basic-burgundy-03",
  "dark blue": "basic-dark-blue-04",
  "dark green": "basic-dark-green-02",
  "light green": "basic-light-green-04",
  "mint": "basic-mint-04",
  "olive": "basic-olive-04",
  "rose pink": "basic-rose-pink-02"
 },
 "signature-flat-sheet-set-with-leaves-embroidery-copy-1": {
  "light grey": "1_20.jpg",
  "beige": "1_15_cdc6932f-22c5-440a-9265-8c51ad3bb200.png"
 },
 "signature-flat-sheet-set-with-leaves-embroidery-copy-2": {
  "beige + brown": "1_54_515f3fe1-f5c3-4df7-a4ce-b3bcf6a55289.png",
  "off white + silver": "1_21_f8e4628a-a803-4243-9aa4-ad1258ca1565.jpg",
  "white + brown": "1_13_a967a4c8-0478-4d9c-81ff-907a41c7292c.jpg"
 },
 "signature-flat-sheet-set-with-leaves-embroidery-copy": {
  "beige + brown embroiedry": "1_22.jpg",
  "off white + white embroiedry": "1_55.png",
  "beige + white embroiedry": "1_83_8e0204b2-a6cf-4607-952d-0db549ce12c2.png",
  "white + silver embroiedry": "1_14.jpg"
 },
 "stockholm": {
  "gray": "1_28.png",
  "beige": "1_1.png",
  "pink": "1_5.png",
  "sage": "1_1.jpg",
  "purple": "1_4.png"
 },
 "serene-towels": {
  "gray": "N1_4.png",
  "white": "1_29.png",
  "pistage": "N1_3.png",
  "royal blue": "N1_1.png"
 },
 "sage-towel-set": {
  "gray": "1_3.png",
  "beige": "t2_5.png",
  "white": "t2_4.png",
  "pistage": "t2_1.png",
  "petroleum": "t2_2.png"
 },
 "the-jacquard-light-weight-quilt": {
  "silver / black & white": "1_70.png"
 },
 "the-embroidery-quilt": {
  "natural cream": "1_79_a6e218d8-b716-4565-ba4d-0bdd5fbc749a.png",
  "delicate mint": "1_13_5d27ed69-c706-4743-b073-f4891d673529.png",
  "soft blue": "1_57.png",
  "warm beige": "1_9.png"
 },
 "the-jacquard-woven-coverlet": {
  "sage green": "1_39.png",
  "pink": "1_16.png",
  "turquoise": "1_38.png",
  "off white": "1_37.png"
 },
 "the-honey-comb-coverlet": {
  "beige / natural": "1_80.png",
  "sage green": "1_25.png",
  "blush pink": "1_26.png"
 },
 "prestige-flap-pillow-case-set": {
  "off white": "Member_s_Mark_Washed_Cotton_Textured_Sheet_Set_Assorted_Sizes_and_Colors__-_White_California_King.jpg",
  "dark green": "green_flap.png"
 },
 "prestige-oxford-pillow-case-set": {
  "dark green": "green_oxf.png",
  "light pink": "light_piink_oxf.png"
 },
 "prestige-duvet-cover-set": {
  "light pink": "light_piink_oxf.png",
  "dark green": "green_oxf.png",
  "mint": "1_62_5f010785-788a-402d-adbc-7da32da51116.png"
 },
 "prestige-flat-sheet-set": {
  "dark green": "green_oxf.png",
  "light pink": "light_piink_oxf.png"
 },
 "prestige-fitted-sheet-set": {
  "off white": "Frette_Cotton_Sateen_600_TC_Fitted_Bottom_Sheet_in_White_Size_Cal_King___Made_In_Italy.png",
  "navy": "Fitted2_87ae3333-e0a0-49fe-aaa3-0f5643fa64cd.png",
  "beige": "Fitted1_2321e612-fbba-46d6-9f76-39d178b8a3a0.png",
  "light pink": "light_rose_fitted.png",
  "dark green": "Fitted3_fc8de240-f964-4203-946f-9beedac246d5.png"
 },
 "grace-oxford-pillow-case-set": {
  "white": "1_45.png"
 },
 "grace-duvet-cover-set": {
  "ivory": "1000ThreadCountStripedSheetsforBed-100_LongStapleEgyptianCotton_Woven1000TCStripeKingWhite-Stripe4PieceBeddingSetHotelQuality.png"
 },
 "grace-flat-sheet-set": {
  "pink": "Gemini_Generated_Image_blyhjcblyhjcblyh.png",
  "mint": "1_8.png"
 },
 "grace-fitted-sheet-set": {
  "off white": "1000ThreadCountStripedSheetsforBed-100_LongStapleEgyptianCotton_Woven1000TCStripeKingWhite-Stripe4PieceBeddingSetHotelQuality.png",
  "ivory": "Pillowcases_-_Cotton_Polyester_Blend_Sateen_Stripes_-_300_Thread_Count.png"
 },
 "signature-duvet-cover-set-with-embroidery": {
  "light grey": "Gemini_Generated_Image_9lkb5u9lkb5u9lkb.png",
  "beige": "Gemini_Generated_Image_ege4z9ege4z9ege4_f14c36e2-5f7c-4593-8ee7-79259ad97075.png",
  "off white": "Screenshot_652.png"
 },
 "signature-flat-sheet-set-with-embroidery": {
  "light grey": "1_51_1aca9f45-89ab-4323-8097-50e1224f7daf.png",
  "beige": "1_16_0048b92f-81fc-4121-acae-48d73e189b80.jpg",
  "off white": "1_18_8493ddb4-e9ec-41cc-afbf-2d8b4a74936f.jpg"
 },
 "signature-flap-pillow-case-set": {
  "off white": "Member_s_Mark_Washed_Cotton_Textured_Sheet_Set_Assorted_Sizes_and_Colors__-_White_California_King.jpg",
  "light grey": "WhatsApp_Image_2026-06-05_at_11.27.24_1.jpg"
 },
 "signature-oxford-pillow-case-set": {
  "light grey": "grey_oxf.png"
 },
 "signature-duvet-cover-set": {
  "off white": "WhiteDuvetset_061f18ec-b2f5-4dc9-9a30-9c9734eea284.png",
  "light grey": "duvet_set_grey_f20ba5e2-106e-432b-9046-3a18205728b4.png"
 },
 "signature-flat-sheet-set": {
  "off white": "white_set.png",
  "light grey": "flat_set_grey.png",
  "beige": "Screenshot_439.png"
 },
 "signature-fitted-sheet-set": {
  "off white": "white_fitted_set.png"
 },
 "essential-flat-sheet-set": {
  "lilac": "lavender.png"
 },
/* TESSERA Flex. Not one of the 54 variants has a photo assigned in Shopify,
    and the CSV that would assign them will not import, so the colour -> photo
    link is made here instead, out of the photographs already on each product.
    Petrolic has no photograph anywhere in the client's folder and is left out
    on every product, so it falls back to the main picture rather than showing
    another colour. */
 "flex-flap-pillow-case-set": {
  "blue": "WhatsAppImage2026-06-04at4.10.54AM.jpg",
  "cashmere": "1_43.png"
 },
 "flex-oxford-pillow-case-set": {
  "off-white": "OffWhite.png",
  "beige": "Beige.png",
  "mint": "Mint.png",
  "blue": "Blue.png",
  "cashmere": "Cashmere.png"
 },
 /* The four real duvet colourways, added to the product by hand because the
    CSV would not import. Off-white and Petrolic have no photograph. The two
    photos that were here before - a Homescapes stock shot and an AI-generated
    lineup - are deliberately left unmapped. */
 "tessera-flex-duvet-set": {
  "beige": "flex-duvet-beige.jpg",
  "blue": "flex-duvet-blue.jpg",
  "cashmere": "flex-duvet-cashmere.jpg",
  "mint": "flex-duvet-mint.jpg"
 },
 "tessera-flex-flat-sheet-set": {
  "off-white": "TesseraFlexsheetsetOffwhite",
  "beige": "TesseraFlexsheetsetBeige",
  "mint": "TesseraFlexsheetsetLightMint",
  "blue": "TesseraFlexsheetsetBlue",
  "cashmere": "TesseraFlexsheetsetCashmere"
 },
 /* Beige and Cashmere were pointing at the wrong files - beige at the pink
    sheet and cashmere at the five-colour stack. Corrected against the photos. */
 "tessera-flex-fitted-sheet-set": {
  "off-white": "WhatsAppImage2026-06-04at4.10.55AM_1.jpg",
  "beige": "1_85.png",
  "mint": "1_87.png",
  "blue": "1_86.png",
  "cashmere": "WhatsAppImage2026-06-04at4.10.55AM.jpg"
 }
,
/* Bed Spreads & Quilts. None of these products has a variant image assigned
   in Shopify, so the swatches were guessing: Turquoise showed the emerald
   photo and Pink showed the stacked-throws shot. Pinned here by eye plus a
   dominant-hue check on each file.
   Where a square-on bed photograph exists for a colour it wins over the
   flat-lay, so the tile leads with a bed the way the reference does. */
 "the-jacquard-woven-coverlet": {
  "sage green": "1_41.png",
  "turquoise": "1_63.png",
  "pink": "1_65.png",
  "off white": "1_37.png"
 },
 "the-honey-comb-coverlet": {
  "beige / natural": "1_80.png",
  "white / off-white": "1_26.png",
  "sage green": "1_25.png"
  /* Blush Pink, Navy Blue and Sky Blue have no photograph on the product
     yet - the tailored-weave folder is not uploaded. Left unmapped so they
     fall back to the main shot rather than showing the wrong colour. */
 },
 "the-embroidery-quilt": {
  "warm beige": "1_9.png",
  "natural cream": "1_81.png",
  "soft blue": "1_57.png",
  "delicate mint": "1_61.png"
 }
,
 /* Tailored Woven Coverlet - a third coverlet alongside the Honeycomb and the
    Jacquard, same 1,980 price. Navy, White and Beige are unambiguous solo
    shots; Sky Blue and Sage Green are the best read of the two that remain.
    Blush Pink has no photograph in the client's folder. */
 "the-tailored-woven-coverlet": {
  "beige / natural": "spread-tailored-coverlet-01",
  "white / off-white": "spread-tailored-coverlet-02",
  "navy blue": "spread-tailored-coverlet-03",
  "sky blue": "spread-tailored-coverlet-04",
  "sage green": "spread-tailored-coverlet-05"
 }
};
